export const rangoInversion = (rango: string, maxLength: number) => {
    const arr = [];
    for( let i=0; i< rango.length; i++ ){
        arr.push(<span className="naranja">$</span>)
    }
    for(let i = 0; i < maxLength - rango.length; i++ ){
        arr.push(<span>$</span>)
    }
    return arr;
}